import {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

export enum OngoingABTests {
    PLANER_VERIFICATION = "PLANER_VERIFICATION",
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    ARTICLE_ATTACHMENT_PAYWALL = "ARTICLE_ATTACHMENT_PAYWALL",
    CREDIT_CALCULATOR_PAYWALL = "CREDIT_CALCULATOR_PAYWALL",
    PRE_MULTI_LEAD = "PRE_MULTI_LEAD"
}

/**
 * Hidden prices - in the future, tests will probably be restored (in some form), below is the MR that removed that test.
 * @see https://git.rynekpierwotny.com/propertygroup/mono/-/merge_requests/3606
 */

export enum PreMultiLeadVariant {
    VISIBLE = 0,
    HIDDEN = 1
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    {
        id: "kjKPhh297pzx57xxlmoi",
        expires: new Date(2026, 11, 1),
        name: OngoingABTests.ARTICLE_ATTACHMENT_PAYWALL,
        path: [rpAppPath.article.detail],
        matchOnAllPaths: false,
        variants: 1,
        withSSR: true
    },
    {
        id: "d8oo07mmmgzj77yyuzoi",
        expires: new Date(2025, 11, 30),
        name: OngoingABTests.PRE_MULTI_LEAD,
        path: [rpAppPath.property.detail.base],
        matchOnAllPaths: true,
        variants: 1,
        variantConfig: {
            [PreMultiLeadVariant.VISIBLE]: 0.2,
            [PreMultiLeadVariant.HIDDEN]: 0.8
        },
        withSSR: true
    },
    {
        id: "ttKZLL297pzxxnnnlmpk",
        expires: new Date(2026, 11, 31),
        name: OngoingABTests.CREDIT_CALCULATOR_PAYWALL,
        path: [rpAppPath.credits.offers],
        matchOnAllPaths: false,
        variants: 1,
        withSSR: false
    }
];
import {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

export enum OngoingABTests {
    PLANER_VERIFICATION = "PLANER_VERIFICATION",
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    ARTICLE_ATTACHMENT_PAYWALL = "ARTICLE_ATTACHMENT_PAYWALL",
    CREDIT_CALCULATOR_PAYWALL = "CREDIT_CALCULATOR_PAYWALL",
    PRE_MULTI_LEAD = "PRE_MULTI_LEAD"
}

/**
 * Hidden prices - in the future, tests will probably be restored (in some form), below is the MR that removed that test.
 * @see https://git.rynekpierwotny.com/propertygroup/mono/-/merge_requests/3606
 */

export enum PreMultiLeadVariant {
    VISIBLE = 0,
    HIDDEN = 1
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    {
        id: "kjKPhh297pzx57xxlmoi",
        expires: new Date(2026, 11, 1),
        name: OngoingABTests.ARTICLE_ATTACHMENT_PAYWALL,
        path: [rpAppPath.article.detail],
        matchOnAllPaths: false,
        variants: 1,
        withSSR: true
    },
    {
        id: "d8oo07mmmgzj77yyuzoi",
        expires: new Date(2025, 11, 30),
        name: OngoingABTests.PRE_MULTI_LEAD,
        path: [rpAppPath.property.detail.base],
        matchOnAllPaths: true,
        variants: 1,
        variantConfig: {
            [PreMultiLeadVariant.VISIBLE]: 0.2,
            [PreMultiLeadVariant.HIDDEN]: 0.8
        },
        withSSR: true
    },
    {
        id: "ttKZLL297pzxxnnnlmpk",
        expires: new Date(2026, 11, 31),
        name: OngoingABTests.CREDIT_CALCULATOR_PAYWALL,
        path: [rpAppPath.credits.offers],
        matchOnAllPaths: false,
        variants: 1,
        withSSR: false
    }
];
